<template>
  <auth-guard
    route
  >
    <v-container v-if="inventory">
      <url-breadcrumbs
        v-if="inventory"
        :items="[
          ['inventory list', { name: 'inventory-list' }],
          inventory.url
        ]"
      />
      <v-row v-if="!loading">
        <base-title>
          {{ `Inventory ${inventory.name}` }}
        </base-title>
      </v-row>
      <v-skeleton-loader
        v-if="loading"
        type="card"
      />
      <inv-details-section
        v-else
        :inventory="inventory"
        :lot-types="lotTypes"
      />
      <br>
      <v-skeleton-loader
        v-if="loading"
        type="table"
      />
      <inventory-lines-section
        v-else
        :container-types="containerTypes"
        :inventory-lines="inventory.inventoryline_set"
      />
    </v-container>
  </auth-guard>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InvDetailsSection from './components/InvDetailsSection'
import InventoryLinesSection from './components/InventoryLinesSection.vue'

export default {
  name: 'Inventory',
  components: {
    InvDetailsSection,
    InventoryLinesSection
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters({
      inventory: 'inventoryStore/inventory',
      containerTypes: 'inventoryStore/containerTypes',
      lotTypes: 'lotStore/lotTypes'
    })
  },
  methods: {
    ...mapActions({
      fetchRequirements: 'inventoryStore/fetchInventory'
    })
  },
  async mounted () {
    await this.fetchRequirements(this.$route.params.id)
    this.loading = false
  }
}
</script>
